<template>
  <div class="modal fade" v-bind:id="'grantAppReminderModal' + IdString">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Set Reminder</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="setReminder">
            <div class="form-group">
              <label v-bind:for="'reminderDescription' + IdString"
                >Reminder</label
              >
              <input
                class="form-control"
                v-model="grantReminderDescription"
                v-bind:id="'reminderDescription' + IdString"
                placeholder="Description"
              />
            </div>
            <div class="form-group">
              <label v-bind:for="'reminderDate' + IdString"
                >Reminder Date</label
              >
              <datepicker
                v-model="grantReminderDate"
                v-bind:id="'grantReminderDate' + IdString"
                format="MM/dd/yyyy"
                @selected="grantReminderDateSelected"
              />
            </div>
            <button type="submit" class="btn btn-primary float-right mr-2">
              Set Reminder
            </button>
            <button
              type="button"
              class="btn btn-secondary float-right"
              data-dismiss="modal"
              style="margin-right: 0.5rem;"
            >
              Cancel
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import datepicker from "vuejs-datepicker";
import $ from "jquery";

export default {
  name: "GrantAppReminderModal",
  components: {
    datepicker
  },
  props: {
    GrantApplicationId: String,
    IdString: String
  },
  data() {
    return {
      grantApplicationId: this.GrantApplicationId,
      grantReminderDate: Date,
      grantReminderDescription: ""
    };
  },
  watch: {
    GrantApplicationId: function() {
      this.grantApplicationId = this.GrantApplicationId;
      this.grantReminderDate = new Date();
      this.grantReminderDescription = "";
    }
  },
  mounted() {
    this.grantReminderDate = new Date();
  },
  methods: {
    async setReminder() {
      var view = this;
      view.$store.commit("updateLoading", true);
      try {
        var reminderDate = new Date(view.$data.grantReminderDate);
        reminderDate.setHours(0, 0, 0, 0);
        await view.$store.getters.fetcher({
          query: `mutation($grantApplicationId: Int!, $description: String!, $date: Date!){
              CreateGrantApplicationReminder(grantApplicationId: $grantApplicationId, description: $description, date: $date)
              {
                Grant_Application_Id
              }
            }`,
          variables: {
            grantApplicationId: parseInt(view.$data.grantApplicationId),
            description: view.$data.grantReminderDescription,
            date: reminderDate
          }
        });
        view.$emit("createdGrantReminder");
      } catch (e) {
        console.log(e);
        view.$store.commit("updateLoading", false);
      }
      view.$store.commit("updateLoading", false);
      $("#grantAppReminderModal" + view.IdString).modal("hide");
      view.$data.grantReminderDate = new Date();
      view.$data.grantReminderDescription = "";
    },
    grantReminderDateSelected(newDate) {
      this.grantReminderDate = newDate;
    }
  }
};
</script>

<style>
#grantReminderDate {
  width: 100%;
  height: calc(1.5rem + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  color: #495057;
  line-height: 1.5;
  border-radius: 0.25rem;
  border: 1px solid #ced4da;
}
</style>
